var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAb2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 55,
    viewBox: "0 0 46 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5223 23.6406C28.0505 23.6406 33.3426 18.3485 33.3426 11.8203C33.3426 5.29212 28.0505 0 21.5223 0C14.9942 0 9.70206 5.29212 9.70206 11.8203C9.70206 18.3485 14.9942 23.6406 21.5223 23.6406Z",
    fill: "#00E194"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9924 52.8582C27.5069 54.373 29.9448 54.373 34.8204 54.373C39.696 54.373 42.1339 54.373 43.6484 52.8582C45.1632 51.3438 45.1632 48.9058 45.1632 44.0303C45.1632 39.1547 45.1632 36.7167 43.6484 35.2023C42.1339 33.6875 39.696 33.6875 34.8204 33.6875C29.9448 33.6875 27.5069 33.6875 25.9924 35.2023C24.4777 36.7167 24.4777 39.1547 24.4777 44.0303C24.4777 48.9058 24.4777 51.3438 25.9924 52.8582ZM31.9439 48.3934C29.8692 46.9079 27.4327 45.1629 27.4327 42.1384C27.4327 38.7995 31.496 36.4313 34.8204 39.6414C38.1449 36.4313 42.2081 38.7995 42.2081 42.1384C42.2081 45.1629 39.7716 46.9079 37.6969 48.3934C37.4815 48.5477 37.2696 48.6993 37.0651 48.8494C36.2979 49.4111 35.5592 49.9404 34.8204 49.9404C34.0816 49.9404 33.3429 49.4111 32.5757 48.8494C32.3713 48.6993 32.1594 48.5477 31.9439 48.3934Z",
    fill: "#00E194"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2776 51.4102C22.1134 49.7344 22.1134 47.6246 22.1134 44.9166C22.1134 38.7873 22.1134 35.7225 24.0176 33.8186C25.9216 31.9143 28.9864 31.9143 35.1157 31.9143C35.8717 31.9143 36.5812 31.9143 37.2476 31.9179C33.4537 29.3836 27.8163 27.7773 21.5225 27.7773C10.0982 27.7773 0.836975 33.0696 0.836975 39.5976C0.836975 46.1257 10.0982 51.4179 21.5225 51.4179C21.7753 51.4179 22.027 51.4153 22.2776 51.4102Z",
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAb2);
export default __webpack_public_path__ + "static/media/ab_2.af1522f9a517741822d0e12eda4b83d8.svg";
export { ForwardRef as ReactComponent };